import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { isType, isObjectType, isInterfaceType, isInputObjectType, isEnumType, isUnionType } from "graphql";
import { pick, useGraphiQL, Spinner, PanelHeader } from "@graphiql/react";
import { useDocExplorer, useDocExplorerActions } from "../context.js";
import { Breadcrumb } from "./breadcrumb.js";
import { FieldDocumentation } from "./field-documentation.js";
import { FieldsList } from "./fields-list.js";
import { SchemaDocumentation } from "./schema-documentation.js";
import { SearchRow } from "./search-row.js";
import { TypeCard } from "./type-card.js";
import { TypeDocumentation } from "./type-documentation.js";
/* empty css                 */
const DocExplorer = () => {
  const $ = c(37);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = pick("fetchError", "isIntrospecting", "schema", "validationErrors");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetchError,
    isIntrospecting,
    schema,
    validationErrors
  } = useGraphiQL(t0);
  const explorerNavStack = useDocExplorer();
  const {
    pop
  } = useDocExplorerActions();
  let content;
  let navItem;
  let navigateToIndex;
  if ($[1] !== explorerNavStack || $[2] !== fetchError || $[3] !== isIntrospecting || $[4] !== pop || $[5] !== schema || $[6] !== validationErrors) {
    navItem = explorerNavStack.at(-1);
    let t12;
    if ($[10] !== explorerNavStack.length || $[11] !== pop) {
      t12 = (index) => {
        const stepsBack = explorerNavStack.length - 1 - index;
        for (let i = 0; i < stepsBack; i++) {
          pop();
        }
      };
      $[10] = explorerNavStack.length;
      $[11] = pop;
      $[12] = t12;
    } else {
      t12 = $[12];
    }
    navigateToIndex = t12;
    content = null;
    if (fetchError) {
      let t22;
      if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = /* @__PURE__ */ jsx("div", { className: "graphiql-doc-explorer-error", children: "Error fetching schema" });
        $[13] = t22;
      } else {
        t22 = $[13];
      }
      content = t22;
    } else {
      if (validationErrors[0]) {
        let t22;
        if ($[14] !== validationErrors[0].message) {
          t22 = /* @__PURE__ */ jsxs("div", { className: "graphiql-doc-explorer-error", children: [
            "Schema is invalid: ",
            validationErrors[0].message
          ] });
          $[14] = validationErrors[0].message;
          $[15] = t22;
        } else {
          t22 = $[15];
        }
        content = t22;
      } else {
        if (isIntrospecting) {
          let t22;
          if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
            t22 = /* @__PURE__ */ jsx(Spinner, {});
            $[16] = t22;
          } else {
            t22 = $[16];
          }
          content = t22;
        } else {
          if (!schema) {
            let t22;
            if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
              t22 = /* @__PURE__ */ jsx("div", { className: "graphiql-doc-explorer-error", children: "No GraphQL schema available" });
              $[17] = t22;
            } else {
              t22 = $[17];
            }
            content = t22;
          } else {
            if (explorerNavStack.length === 1) {
              let t22;
              if ($[18] !== schema) {
                t22 = /* @__PURE__ */ jsx(SchemaDocumentation, { schema });
                $[18] = schema;
                $[19] = t22;
              } else {
                t22 = $[19];
              }
              content = t22;
            } else {
              if (isType(navItem.def)) {
                let t22;
                if ($[20] !== navItem.def) {
                  t22 = /* @__PURE__ */ jsx(TypeView, { type: navItem.def });
                  $[20] = navItem.def;
                  $[21] = t22;
                } else {
                  t22 = $[21];
                }
                content = t22;
              } else {
                if (navItem.def) {
                  let t22;
                  if ($[22] !== navItem.def) {
                    t22 = /* @__PURE__ */ jsx(FieldDocumentation, { field: navItem.def });
                    $[22] = navItem.def;
                    $[23] = t22;
                  } else {
                    t22 = $[23];
                  }
                  content = t22;
                }
              }
            }
          }
        }
      }
    }
    $[1] = explorerNavStack;
    $[2] = fetchError;
    $[3] = isIntrospecting;
    $[4] = pop;
    $[5] = schema;
    $[6] = validationErrors;
    $[7] = content;
    $[8] = navItem;
    $[9] = navigateToIndex;
  } else {
    content = $[7];
    navItem = $[8];
    navigateToIndex = $[9];
  }
  const isTypeOrFieldView = explorerNavStack.length > 1;
  let t1;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /* @__PURE__ */ jsx(PanelHeader, { title: "Schema Explorer" });
    $[24] = t1;
  } else {
    t1 = $[24];
  }
  let t2;
  if ($[25] !== explorerNavStack || $[26] !== isTypeOrFieldView || $[27] !== navigateToIndex) {
    t2 = isTypeOrFieldView && /* @__PURE__ */ jsx(Breadcrumb, { navStack: explorerNavStack, onNavigateTo: navigateToIndex });
    $[25] = explorerNavStack;
    $[26] = isTypeOrFieldView;
    $[27] = navigateToIndex;
    $[28] = t2;
  } else {
    t2 = $[28];
  }
  let t3;
  if ($[29] !== navItem.name) {
    t3 = /* @__PURE__ */ jsx(SearchRow, {}, navItem.name);
    $[29] = navItem.name;
    $[30] = t3;
  } else {
    t3 = $[30];
  }
  let t4;
  if ($[31] !== content) {
    t4 = /* @__PURE__ */ jsx("div", { className: "graphiql-doc-explorer-content", children: content });
    $[31] = content;
    $[32] = t4;
  } else {
    t4 = $[32];
  }
  let t5;
  if ($[33] !== t2 || $[34] !== t3 || $[35] !== t4) {
    t5 = /* @__PURE__ */ jsxs("section", { className: "graphiql-doc-explorer", "aria-label": "Documentation Explorer", children: [
      t1,
      t2,
      t3,
      t4
    ] });
    $[33] = t2;
    $[34] = t3;
    $[35] = t4;
    $[36] = t5;
  } else {
    t5 = $[36];
  }
  return t5;
};
const TypeView = (t0) => {
  const $ = c(16);
  const {
    type
  } = t0;
  let t1;
  if ($[0] !== type) {
    t1 = isObjectType(type) || isInterfaceType(type) || isInputObjectType(type);
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hasNewFieldsList = t1;
  let t2;
  if ($[2] !== type) {
    t2 = isEnumType(type) || isUnionType(type) || isInterfaceType(type);
    $[2] = type;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const needsTypeDocs = t2;
  let t3;
  if ($[4] !== type) {
    t3 = /* @__PURE__ */ jsx(TypeCard, { type });
    $[4] = type;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== hasNewFieldsList || $[7] !== type) {
    t4 = hasNewFieldsList && /* @__PURE__ */ jsx(FieldsList, { type });
    $[6] = hasNewFieldsList;
    $[7] = type;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== needsTypeDocs || $[10] !== type) {
    t5 = needsTypeDocs && /* @__PURE__ */ jsx("div", { className: "graphiql-doc-explorer-type-extra", children: /* @__PURE__ */ jsx(TypeDocumentation, { type, hideHeader: true }) });
    $[9] = needsTypeDocs;
    $[10] = type;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = /* @__PURE__ */ jsxs(Fragment, { children: [
      t3,
      t4,
      t5
    ] });
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export {
  DocExplorer
};
//# sourceMappingURL=doc-explorer.js.map
